import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';

export class WillsNoticeSearchInstructionsExportService extends ExportTypeBaseService {
  getFilename(): string {
    return 'wills-notice-search-instructions.pdf';
  }

  getSnackBarTitle(): string {
    return Lang.t('guidancestep.wills-notice-search-exporting');
  }
}
export default new WillsNoticeSearchInstructionsExportService();
